import { YouTubePlayer } from "react-youtube";
import "./tutoButtonYou.css";
import { useEffect, useState } from "react";
import { CloseCircleOutlined } from "@ant-design/icons";

const TutorialButtonYouTube = ({
  video,
  title,
}: {
  video: string;
  title: string;
}) => {
  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [popupVisible, setPopupVisible] = useState(false);

  const openPopup = () => {
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
  };

  return (
    <>
      {width > 768 && (
        <div className="leftos">
          <button className="buttonxo" onClick={openPopup}>
            <span className="icon">
              <svg
                fill="none"
                height="33"
                viewBox="0 0 120 120"
                width="33"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m120 60c0 33.1371-26.8629 60-60 60s-60-26.8629-60-60 26.8629-60 60-60 60 26.8629 60 60z"
                  fill="#cd201f"
                ></path>
                <path
                  d="m25 49c0-7.732 6.268-14 14-14h42c7.732 0 14 6.268 14 14v22c0 7.732-6.268 14-14 14h-42c-7.732 0-14-6.268-14-14z"
                  fill="#fff"
                ></path>
                <path d="m74 59.5-21 10.8253v-21.6506z" fill="#cd201f"></path>
              </svg>
            </span>
            <span className="text1">Guarda Tutorial</span>
            <span className="text2">Riproduci</span>
          </button>
        </div>
      )}
      {width <= 768 && (
        <div className="leftosso">
          <button className="buttonxo" onClick={openPopup}>
            <span className="icon">
              <svg
                fill="none"
                height="33"
                viewBox="0 0 120 120"
                width="33"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m120 60c0 33.1371-26.8629 60-60 60s-60-26.8629-60-60 26.8629-60 60-60 60 26.8629 60 60z"
                  fill="#cd201f"
                ></path>
                <path
                  d="m25 49c0-7.732 6.268-14 14-14h42c7.732 0 14 6.268 14 14v22c0 7.732-6.268 14-14 14h-42c-7.732 0-14-6.268-14-14z"
                  fill="#fff"
                ></path>
                <path d="m74 59.5-21 10.8253v-21.6506z" fill="#cd201f"></path>
              </svg>
            </span>
            <span className="text1">Guarda Tutorial</span>
            <span className="text2">Riproduci</span>
          </button>
        </div>
      )}
      {width > 768 && popupVisible && (
        //Screen PC
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup">
            <span className="close-btn" onClick={closePopup}>
              <CloseCircleOutlined rev={undefined} className="icones" />
            </span>
            <div className="video-container">
              <iframe
                width="765"
                height="472.5"
                src={video}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
      {width <= 768 && popupVisible && (
        //Screen Mobile
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup">
            <span className="close-btn" onClick={closePopup}>
              <CloseCircleOutlined rev={undefined} className="icones" />
            </span>
            <div className="video-container">
              <iframe
                width="560"
                height="315"
                src={video}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TutorialButtonYouTube;
